// Mock data for Primezeit Landing Page
// UPDATED COPY: "No-Bullshit" Ton, biologische Logik, Accountability als Hauptversprechen

export const siteConfig = {
  logo: "https://cdn.prod.website-files.com/68e7b10b3976a460110ac4d3/68ea002732ea05a4ca2d37db_Logo%20Builder.png",
  bookingUrl: "https://api.leadconnectorhq.com/widget/bookings/arseni-lasnov",
  bookingCta: "Kostenloses Analysegespräch",
  instagramUrl: "https://www.instagram.com/arsenibiohack/",
  youtubeUrl: "https://www.youtube.com/@arsenibio",
  shopUrl: "https://peptidebestellung.de/?ref=ARSENI10",
  whatsappNumber: "491725985145",
  whatsappMessage: "Hi Arseni, ich komme von deiner Webseite und interessiere mich für dein Coaching rund um Abnehmen und ganzheitliche Gesundheit. Ich wollte dich kontaktieren wegen:",
};

export const heroData = {
  badge: "1:1 Biohacking-Coaching für Männer",
  headline: "Abnehmen mit System.",
  subheadline: "Peptide verstehen. Gesundheit ganzheitlich optimieren.",
  description: "Ich helfe dir, Ernährung, Training, Schlaf und Stoffwechsel in ein klares System zu bringen – und Peptide sachlich einzuordnen, statt blind dem nächsten Hype zu folgen.",
  ctaText: "Kostenloses Analysegespräch",
  secondaryCta: "So funktioniert es",
  features: [
    "Ganzheitliche Analyse",
    "Individuelle Strategie",
    "Wöchentliche Begleitung"
  ]
};

export const peptidePositioningData = {
  badge: "PEPTIDE RICHTIG EINORDNEN",
  title: "Peptide sind ein Werkzeug – kein kompletter Plan.",
  description: "Nachhaltige Veränderung entsteht nicht durch einen einzelnen Wirkstoff. Entscheidend ist, wie Ernährung, Training, Schlaf, Stress und Alltag zusammenspielen. Im Coaching bekommst du dafür ein umsetzbares System und eine klare Einordnung, welche Fragen du bei Peptiden mit qualifizierten medizinischen Ansprechpartnern klären solltest.",
  pillars: [
    {
      title: "Fundament zuerst",
      description: "Wir schaffen Routinen für Ernährung, Bewegung, Schlaf und Regeneration, die du im echten Alltag durchhalten kannst."
    },
    {
      title: "Einordnung statt Hype",
      description: "Du lernst Nutzenversprechen, Grenzen und Risiken kritisch zu bewerten – ohne Ferndiagnosen oder Selbstmedikation."
    },
    {
      title: "Messbare Begleitung",
      description: "Wir beobachten Fortschritt, Energie, Alltag und Umsetzung und passen dein System Schritt für Schritt an."
    }
  ],
  youtubeCta: "Peptide auf YouTube verstehen",
  shopPrompt: "Du weißt bereits, wonach du suchst?",
  shopCta: "Zum Peptid-Shop",
  shopNote: "Mit ARSENI10 sparst du 10 %."
};

export const targetAudienceData = {
  sectionHeadline: "Erkennst du dich wieder?",
  sectionSubheadline: "Für Männer, die abnehmen und ihre Gesundheit verbessern wollen – ohne den nächsten kurzfristigen Schnellschuss.",
  forYou: {
    title: "Richtig für dich:",
    items: [
      "Du willst Körperfett verlieren, aber nicht wieder mit einer Crash-Diät starten, die nach wenigen Wochen endet.",
      "Du hast viel über Peptide, Ernährung und Biohacking gehört, kannst Nutzen, Grenzen und Risiken aber noch nicht sauber einordnen.",
      "Du trainierst und achtest auf deine Ernährung, doch Schlaf, Stress oder fehlende Struktur bremsen deine Umsetzung.",
      "Du möchtest deine Gesundheit ganzheitlich betrachten, statt nur Kalorien oder einzelne Laborwerte isoliert zu verfolgen.",
      "Du willst klare nächste Schritte, regelmäßige Kontrolle und ein System, das zu deinem Alltag passt."
    ]
  },
  notForYou: {
    title: "Nicht für dich:",
    items: [
      "Du suchst eine Wunderlösung, bei der Ernährung, Bewegung und Gewohnheiten keine Rolle spielen sollen.",
      "Du erwartest eine Diagnose, ein Rezept oder eine medizinische Behandlung – das ist nicht Teil dieses Coachings.",
      "Du möchtest Peptide ohne ärztliche Abklärung oder kritische Auseinandersetzung einsetzen.",
      "Du willst keine Daten, Routinen oder Fortschritte dokumentieren und auch keine regelmäßigen Check-ins.",
      "Du suchst ein starres Standardprogramm, das für jeden Menschen identisch ist."
    ]
  }
};

export const problemMechanismData = {
  problem: {
    title: "DAS PROBLEM",
    subtitle: "Das Problem bist nicht du, sondern das System.",
    subtext: "Und warum das nicht deine Schuld ist.",
    points: [
      {
        title: "Zu viele widersprüchliche Informationen",
        description: "Keto, Carbs, Fasten, Supplements, Peptide – jede Woche wirkt etwas anderes wie die eine Lösung. Dadurch fehlt dir ein klarer, umsetzbarer Weg."
      },
      {
        title: "Einzelmaßnahmen ohne Gesamtbild",
        description: "Nur Kalorien zu zählen oder ein neues Produkt zu testen reicht nicht, wenn Schlaf, Stress, Training und Alltag gegeneinander arbeiten."
      },
      {
        title: "Keine Accountability",
        description: "Du versuchst es alleine: Supplements gekauft. Diät angefangen und nach 2 Wochen wieder abgebrochen. Das Problem ist, dass niemand für dich da ist, der dich kontrolliert und auf Kurs hält."
      },
      {
        title: "Peptid-Hype ohne Einordnung",
        description: "Social Media zeigt oft nur Versprechen. Fragen zu Grenzen, Risiken und medizinischer Abklärung bleiben offen – genau dort entsteht unnötiger Blindflug."
      }
    ]
  },
  solution: {
    title: "DIE LÖSUNG",
    subtitle: "Nicht besser – ANDERS.",
    points: [
      {
        title: "EIN System, keine 1000 Meinungen",
        description: "Du bekommst klare Prioritäten für Ernährung, Bewegung, Schlaf und Umsetzung – passend zu deinem Alltag und deinem Ausgangspunkt."
      },
      {
        title: "Peptide sachlich verstehen",
        description: "Wir trennen belastbare Informationen von Marketing und entwickeln einen Fragenkatalog für Gespräche mit qualifizierten medizinischen Ansprechpartnern."
      },
      {
        title: "Wöchentliche Begleitung – früh nachsteuern",
        description: "Wir prüfen jede Woche, was funktioniert und wo du aus der Spur kommst. So können wir dein System rechtzeitig anpassen, bevor aus einem Rückschritt ein kompletter Abbruch wird."
      },
      {
        title: "Individuell auf DEINE Daten",
        description: "Kein Copy-Paste-Plan. Wir orientieren uns an deinem Alltag, deinen Gewohnheiten, deinem Fortschritt und den Daten, die für das Coaching wirklich relevant sind."
      }
    ]
  }
};

export const testimonialsData = [
  {
    id: 1,
    name: "Besmir",
    role: "Unternehmer – Voclain, Innoversity",
    imageBefore: "https://cdn.prod.website-files.com/68e7b10b3976a460110ac4d3/68e90cec20dff9b72168107b_Bodybuilder%20Man.webp",
    imageAfter: "https://storage.googleapis.com/msgsndr/lSRBjSsWvvTEe9W0zWpI/media/6962e91598efbdb5cbca6b2b.png",
    headline: "15kg leichter, Rauchfrei, Muay-Thai-Kampf gewonnen.",
    quote: "Ich hatte alle Infos und wusste theoretisch alles über Ernährung. Trotzdem war ich übergewichtig, Raucher und hatte keine Energie mehr. Arseni hat mir nicht noch mehr Infos gegeben – er hat mir gesagt, was ich MACHEN soll. Jeden Tag, ohne Diskussion.",
    results: [
      "15 kg abgenommen",
      "Endlich Rauchfrei",
      "Muay-Thai Kampf gewonnen",
      "Als Unternehmer"
    ],
    fullStory: "Ich bin Unternehmer – Voclain, Innoversity, zwei Firmen aufgebaut. Aber mein Körper? Den habe ich jahrelang komplett vernachlässigt. Dabei wusste ich ALLES über Fitness: YouTube, Podcasts, Bücher, ich hatte mir alles angesehen. Trotzdem hatte ich 15kg Übergewicht, war Kettenraucher und nachmittags war ich komplett tot. Das Problem war nie das Wissen. Das Problem war, dass mir niemand gesagt hat, was ICH konkret machen soll. Arseni hat das geändert. Nicht dieses 'Finde deinen Weg'-Gelaber, sondern klare Ansagen: 'Mach genau das. Jetzt. Und am Freitag kontrolliere ich, ob du es gemacht hast.' Ich wurde 15kg leichter, habe endlich mit dem Rauchen aufgehört und mich in Thailand spontan zu einem Muay-Thai-Kampf angemeldet – den ich dann auch gewonnen habe. Das System funktioniert, wenn du machst, was er sagt."
  },
  {
    id: 2,
    name: "Alexander",
    role: "Fitness-Enthusiast, jahrelang Plateau",
    imageBefore: "https://cdn.prod.website-files.com/68e7b10b3976a460110ac4d3/68f22507ba487aafa80d8d50_Testimonial%203.webp",
    imageAfter: "https://cdn.prod.website-files.com/68e7b10b3976a460110ac4d3/68f225061cec50f7e024019b_Testimonial%204.webp",
    headline: "Plateau gelöst – weniger Training, mehr sichtbarer Fortschritt.",
    quote: "Alle sagten mir, ich müsse einfach mehr trainieren. Arseni hat zuerst Schlaf, Regeneration, Ernährung und Trainingsbelastung zusammen betrachtet. Genau das hat gefehlt.",
    results: [
      "Jahrelanges Plateau gelöst",
      "Sichtbare Muskeln nach Jahren",
      "Bessere Regeneration",
      "Weniger Training"
    ],
    fullStory: "Ich war der Typ, der ALLES probiert hat: Push-Pull-Legs, Ganzkörper, Upper-Lower, Keto, High Carb, Intermittent Fasting und ständig neue Supplements. Das Ergebnis? Nach Jahren Training blieb der Fortschritt aus. Jeder sagte nur: mehr trainieren oder noch genauer tracken. Arseni hat das Gesamtbild geprüft – Schlaf, Regeneration, Stress, Ernährung und Trainingsbelastung – und daraus ein System gebaut, das zu meinem Alltag passt. Heute sehe ich wieder Fortschritt und trainiere dabei sogar weniger als vorher."
  },
  {
    id: 3,
    name: "Leonard",
    role: "Calisthenics-Athlet, Selbständig",
    imageBefore: "https://storage.googleapis.com/msgsndr/lSRBjSsWvvTEe9W0zWpI/media/6962ea7cf13bc32b3078e502.jpg",
    imageAfter: "https://storage.googleapis.com/msgsndr/lSRBjSsWvvTEe9W0zWpI/media/6962ebf6c7683b0bb5839c1b.png",
    headline: "Vom Traum zur Realität – jetzt mehrere Muscle-Ups am Stück.",
    quote: "Ich habe trainiert wie ein Verrückter. Mehr Volumen, mehr Frequenz, mehr von allem. Aber mein Körper hat einfach nicht mitgespielt. Arseni hat mir gezeigt, dass ich an den falschen Stellschrauben gedreht habe.",
    results: [
      "Mehrere Muscle-Ups am Stück",
      "Sichtbarer Muskelaufbau",
      "Bessere Regeneration",
      "Mehr Kraft bei weniger Training"
    ],
    fullStory: "Ich mache seit Jahren Calisthenics und habe immer nur auf Training und Ernährung geachtet. Makros getrackt, Trainingsplan befolgt, alles nach Lehrbuch – sogar zu viel. Ich habe trainiert wie ein Verrückter, aber ein einziger sauberer Muscle-Up blieb ein Traum. Arseni hat mir gezeigt, dass Schlaf, beruflicher Stress und Regeneration genauso zu meinem System gehören. Wir haben zuerst die Basis stabilisiert und erst dann das Training angepasst – weniger, aber smarter. Nach einigen Wochen habe ich nicht nur einen, sondern mehrere saubere Muscle-Ups am Stück geschafft."
  },
  {
    id: 4,
    name: "Slawa",
    role: "Familienvater, 55 Jahre",
    imageBefore: "https://customer-assets.emergentagent.com/job_mens-transformation/artifacts/gvy8y6ip_b472cd1c-a7d5-4486-9bfa-367154c9f4bd.jpeg",
    imageAfter: "https://customer-assets.emergentagent.com/job_mens-transformation/artifacts/w4kiymgd_5f5f2195-2bda-4a6f-b16f-1a225aab8393.jpeg",
    headline: "Mit 55 in der besten Form meines Lebens – das hätte ich nie für möglich gehalten.",
    quote: "Ich dachte, mit Mitte 50 ist der Zug abgefahren. Weniger Energie, mehr Bauch und immer weniger Bewegung. Mein Sohn hat mir gezeigt, dass ich sehr wohl noch etwas verändern kann.",
    results: [
      "Beste Form mit 55",
      "Energie wie mit 35",
      "Bauchfett endlich weg",
      "Neue Routinen aufgebaut"
    ],
    fullStory: "Mit 55 hatte ich mich fast damit abgefunden: Der Bauch wächst, die Energie schwindet und Bewegung fällt immer schwerer. Ich habe das lange als unvermeidlich betrachtet. Dann haben Arseni und ich an den Grundlagen gearbeitet: Schlaf, Stress, Ernährung und ein Training, das meinen Körper unterstützt statt ihn zu überlasten. Nach einigen Monaten war ich wie ausgewechselt: Bauchumfang runter, Muskulatur aufgebaut und wieder deutlich mehr Energie im Alltag. Ich bin stolz auf meinen Sohn – und auf das, was wir zusammen erreicht haben."
  },
  {
    id: 5,
    name: "Daniel",
    role: "Familienvater, Führungsposition, Schichtbetrieb",
    imageBefore: null,
    imageAfter: null,
    headline: "30 Minuten Training reichen aus – wer hätte das gedacht?",
    quote: "Ich dachte, ich habe keine Zeit – 3 Kinder, Schichtarbeit, Führungsposition. Arseni hat mir gezeigt: Es geht nicht um Zeit. Es geht darum, das RICHTIGE zu tun.",
    results: [
      "Fett runter, Muskeln rauf",
      "Ernährung alltagstauglich strukturiert",
      "30 Min Training reichen",
      "Trotz Schichtarbeit"
    ],
    fullStory: "Ich bin Familienvater mit drei Kindern, arbeite in einer Führungsposition im Schichtbetrieb und bin nebenberuflich noch aktiv. Meine Ausrede war immer: 'Keine Zeit.' Arseni hat das zerlegt. Du brauchst keine 2 Stunden im Gym. Du brauchst 30 Minuten – aber die RICHTIGEN 30 Minuten mit dem richtigen Plan. Im ersten Monat habe ich Fett abgebaut und Muskeln aufgebaut: Bauchumfang kleiner, Arme größer – messbar, nicht nur gefühlt. Gleichzeitig habe ich meine Ernährung so strukturiert, dass sie besser zu meinem Schichtalltag und meinem Wohlbefinden passt."
  },
  {
    id: 6,
    name: "Alexander W.",
    role: "Trader, Kopfarbeiter",
    imageBefore: null,
    imageAfter: null,
    headline: "Brain Fog weg – mein Alltag funktioniert wieder.",
    quote: "Als Trader brauche ich einen klaren Kopf. Arseni hat mit mir Schlaf, Stress, Ernährung und Training so strukturiert, dass ich wieder konstant leistungsfähig bin.",
    results: [
      "Brain Fog komplett weg",
      "Konstantere Energie",
      "Besserer Schlaf",
      "Klare Tagesstruktur"
    ],
    fullStory: "Ich bin Trader und mache den ganzen Tag Kopfarbeit. Aber mein Kopf hat irgendwann nicht mehr mitgespielt: Brain Fog, ständig müde und morgens gerädert. Arseni hat meinen Alltag als System betrachtet und mit mir Schlaf, Stress, Ernährung und Training neu strukturiert. Nach einigen Wochen war der Brain Fog verschwunden und ich konnte wieder verlässlich arbeiten, ohne jeden Nachmittag einzubrechen."
  }
];

export const processData = {
  badge: "DEIN WEG",
  title: "So läuft das ab",
  subtitle: "Zuerst lernen wir uns im kostenlosen Analysegespräch kennen. Wenn du dich danach für das Coaching entscheidest, begleiten wir dich Schritt für Schritt.",
  footerText: "Finde im kostenlosen Analysegespräch heraus, ob das Coaching zu dir passt.",
  steps: [
    {
      phase: "Kostenloses Analysegespräch",
      title: "Wir besprechen deine Situation und deine Ziele",
      description: "Buche einen Termin im Kalender. Wir schauen gemeinsam, wo du stehst, was dich bisher bremst und ob eine Zusammenarbeit für dich sinnvoll ist. Das Gespräch ist kostenlos und unverbindlich.",
      duration: "Dein erster Schritt"
    },
    {
      phase: "Onboarding",
      title: "Wir klären deinen Ausgangspunkt und dein Abnehmziel",
      description: "Am Anfang schauen wir auf Alltag, Schlaf, Stress, Ernährung, Bewegung, bisherige Versuche und deine Erwartungen an Peptide. Medizinische Fragen markieren wir klar für die Abklärung mit qualifizierten Fachpersonen.",
      duration: "Tag 1–3"
    },
    {
      phase: "System-Setup",
      title: "Du bekommst dein persönliches Abnehm-System",
      description: "Ernährung, Training, Bewegung, Schlaf und Regeneration werden so aufgebaut, dass sie in deinen Alltag passen. Du weißt, was du konkret tust und woran wir erkennen, ob die Strategie funktioniert.",
      duration: "Woche 1–2"
    },
    {
      phase: "Laufende Betreuung",
      title: "Wir prüfen jede Woche, was wirklich funktioniert",
      description: "Wir kontrollieren Fortschritt, Energie, Routinen und Hindernisse. Wenn etwas nicht in deinen Alltag passt, verändern wir das System frühzeitig, statt auf Perfektion oder Willenskraft zu hoffen.",
      duration: "Fortlaufend"
    },
    {
      phase: "Wissensausbau",
      title: "Du verstehst deinen Körper und Peptid-Informationen besser",
      description: "Du lernst, Ernährung, Training, Regeneration und Biohacking-Informationen kritisch einzuordnen. Das Ziel ist, dass du langfristig selbstständige und verantwortungsvolle Entscheidungen treffen kannst.",
      duration: "Kontinuierlich"
    }
  ]
};

// Coaching-Leistungen ohne öffentliche Preisangaben. Einstieg über das Analysegespräch.
export const offerData = {
  badge: "DAS KOMPLETTE SYSTEM",
  title: "Dein System für nachhaltige Veränderung",
  subtitle: "Abnehmen, Gesundheit und Biohacking – aufeinander abgestimmt und im Alltag umsetzbar.",
  features: [
    { 
      name: "Biohacking- & Abnehm-Onboarding",
      subtitle: "dein persönlicher Standort-Scan",
      description: "Wir erfassen Alltag, Ernährung, Bewegung, Schlaf, Stress und deine bisherigen Abnehmversuche. Daraus entsteht ein realistischer Ausgangspunkt für dein persönliches System.",
    },
    { 
      name: "Individuelle Bewegungs- & Trainingsstrategie",
      subtitle: "dein physisches Fundament",
      description: "Kein stundenlanger Gym-Marathon. Du bekommst eine Struktur für Training und Alltagsbewegung, die zu deiner Zeit, deinem Leistungsstand und deinem Ziel passt.",
    },
    { 
      name: "Persönliche Ernährungsstrategie inkl. Anpassungen",
      subtitle: "",
      description: "Keine komplizierten Rezepte und keine unrealistischen Verbote. Wir schaffen eine Ernährung, die ein Kaloriendefizit ermöglicht und trotzdem zu deinem Alltag passt.",
    },
    { 
      name: "Schlaf, Regeneration & Supplement-Einordnung",
      subtitle: "",
      description: "Wir verbessern Schlaf- und Regenerationsroutinen und ordnen Supplements kritisch ein. Medizinische Fragen und individuelle Einnahmeentscheidungen gehören in fachkundige Hände.",
    },
    { 
      name: "Peptid-Wissen & Entscheidungsrahmen",
      subtitle: "",
      description: "Du lernst, Peptid-Versprechen, Studien, Grenzen und Risiken besser einzuordnen und dich auf Gespräche mit qualifizierten medizinischen Ansprechpartnern vorzubereiten. Keine Diagnose, Verschreibung oder Dosierungsberatung.",
    },
    { 
      name: "24/7 WhatsApp-Support", 
      subtitle: "",
      description: "Fragen zu Umsetzung, Routinen und deinem Coaching-System klären wir direkt. Medizinische Anliegen bleiben ausdrücklich bei Ärzten und anderen qualifizierten Fachpersonen.",
    },
    { 
      name: "Wöchentliche Check-ins & Fortschritts-Tracking",
      subtitle: "",
      description: "Wir prüfen Gewichtstrend, Umfänge, Energie, Routinen und Umsetzung. Wenn du aus der Spur kommst, passen wir dein System an, bevor daraus ein kompletter Abbruch wird.",
    }
  ],
  bonuses: [
    { 
      name: "Monatlicher Primetime-Guide (PDF/Video)", 
      description: "Kompaktes Wissen zu Abnehmen, Schlaf, Gewohnheiten, Biohacking und der kritischen Einordnung neuer Trends – praxisnah und verständlich aufbereitet.",
    },
    { 
      name: "Zugang zum Primetime-Channel", 
      description: "Tägliche Impulse, neue Studien, Biohacks, Routinen und Selbstexperimente – direkt auf dein Handy. Kein Smalltalk, keine Ablenkung, nur purer Input für dein System-Upgrade.",
    },
    { 
      name: "1-Monats-Strategie-Call", 
      description: "Nach dem ersten Monat setzen wir uns zusammen: Wo stehst du? Was hat funktioniert? Wie stellen wir uns die nächsten Monate vor? Ein fokussierter Call, um deinen Fortschritt zu bewerten und die nächsten Schritte zu planen.",
    },
    { 
      name: "Notion-Template & Tracking-Dashboard", 
      description: "Alles auf einen Blick: Makros, Schlaf, Fortschritt, Ziele, Check-ins. Strukturiert, fokussiert und messbar – du siehst immer genau, wo du stehst.",
    }
  ],
  highlights: [
    "Persönliche Begleitung",
    "Individuelle Strategie",
    "Wöchentliche Check-ins"
  ],
  scarcity: "Limitiert auf 20 Plätze"
};

export const coachData = {
  badge: "WER DAHINTER STECKT",
  name: "Arseni",
  title: "Vom eigenen Abnehmweg zum ganzheitlichen System",
  image: "https://cdn.prod.website-files.com/68e7b10b3976a460110ac4d3/690455a84fc9d4f73fdc20a7_91008DB6-EF45-4878-BA4F-626D57B02FDD.webp",
  images: [
    "https://storage.googleapis.com/msgsndr/lSRBjSsWvvTEe9W0zWpI/media/695d8f92de2c14c1874b0aae.jpeg",
    "https://storage.googleapis.com/msgsndr/lSRBjSsWvvTEe9W0zWpI/media/695d8f9294b57d47c4c64677.jpeg",
    "https://storage.googleapis.com/msgsndr/lSRBjSsWvvTEe9W0zWpI/media/695d8f923a532d202857c6f0.jpeg",
    "https://storage.googleapis.com/msgsndr/lSRBjSsWvvTEe9W0zWpI/media/695d8f9222afaa5870d7b33f.jpeg"
  ],
  tagline: "Kein Guru und kein Hochglanz-Coach – sondern jemand, der Übergewicht, fehlende Energie und Informationschaos selbst erlebt hat.",
  bio: "Ich war früher genau da, wo viele Männer heute stehen: übergewichtig, energielos und ständig auf der Suche nach der nächsten Lösung. Ich habe YouTube-Pläne, Supplements und Crash-Diäten ausprobiert – ohne ein System, das wirklich zu meinem Alltag passte. Aus dieser Erfahrung und meinen Biohacking-Ausbildungen ist mein heutiger Ansatz entstanden: Grundlagen konsequent aufbauen, Fortschritt messen und Peptide sachlich einordnen, statt sie als Abkürzung zu verkaufen.",
  credentials: [
    "Biohacking-Ausbildung bei NextVital (staatlich geprüft)",
    "HolisticBio-Ausbildung (ganzheitliches Biohacking)",
    "10+ Jahre Coaching-Erfahrung",
    "Russischer Meister im Schwimmen (Jugend)",
    "Bayerischer Meister im Kickboxen",
    "Aktiver MMA-Leistungssportler"
  ],
  approach: "Ich verspreche dir keine Wunder und ersetze keine medizinische Betreuung. Ich helfe dir, ein klares System aufzubauen, relevante Fragen zu erkennen und die Umsetzung im Alltag durchzuziehen.",
  ctaText: "Kostenloses Analysegespräch"
};

export const faqData = [
  {
    question: "Sind Peptide hier die schnelle Lösung zum Abnehmen?",
    answer: "Nein. Peptide ersetzen weder Ernährung, Bewegung und Schlaf noch eine medizinische Abklärung. Im Coaching bekommst du ein tragfähiges System für die Grundlagen und lernst, Informationen über Peptide, mögliche Grenzen und offene Fragen kritisch einzuordnen."
  },
  {
    question: "Ich habe keine Zeit für 2h Gym jeden Tag.",
    answer: "Musst du auch nicht. Wir bauen das Ganze so, dass es zu deinem Alltag passt – nicht umgekehrt. Entscheidend ist nicht, wie \"perfekt\" es auf dem Papier aussieht, sondern was du realistisch und konstant umsetzen kannst. Egal ob Schichtarbeit, Kinder oder Stress-Job: Wir wählen den kleinsten Aufwand, der die größte Wirkung bringt, und setzen genau dort an."
  },
  {
    question: "Verschreibt Arseni Peptide oder gibt Dosierungspläne?",
    answer: "Nein. Das Coaching ist keine medizinische Behandlung und umfasst keine Diagnose, Verschreibung oder individuelle Dosierungsberatung. Solche Entscheidungen gehören zu qualifizierten Ärzten oder anderen dafür zugelassenen Fachpersonen."
  },
  {
    question: "Funktioniert das bei MIR? Mein Körper ist anders.",
    answer: "Genau deshalb ist es 1:1 Coaching. Wir starten nicht mit einem Copy-Paste-Plan, sondern mit deiner Situation: Alltag, Ziele, Symptome, Routinen und – wenn sinnvoll – auch Werte. Auf dieser Basis bauen wir dein System und optimieren es, bis du merkst, dass dein Körper wieder in die richtige Richtung arbeitet."
  },
  {
    question: "Ist das Analysegespräch wirklich kostenlos?",
    answer: "Ja. Das Analysegespräch ist kostenlos und unverbindlich. Wir besprechen deine Ausgangslage und deine Ziele und klären, ob das Coaching zu dir passt. Mit der Terminbuchung schließt du kein Coaching ab. Über eine Zusammenarbeit entscheidest du erst danach."
  },
  {
    question: "Was, wenn ich wieder versage?",
    answer: "Dann ist das kein \"Charakterproblem\", sondern ein Signal, dass das System an einer Stelle noch nicht gut genug in deinen Alltag integriert ist. Genau dafür sind die Check-ins da: Wir sehen früh, wo du abrutschst, und korrigieren, bevor daraus wieder ein kompletter Abbruch wird. Du musst nicht perfekt sein – du brauchst ein System, das dich auffängt und auf Kurs hält."
  },
  {
    question: "Was hat es mit dem verlinkten Peptid-Shop auf sich?",
    answer: "Über den Link gelangst du direkt zu peptidebestellung.de. Mit ARSENI10 erhältst du 10 % Rabatt."
  }
];

export const faqOutro = {
  text: "Bereit für ein Abnehm-System, das zu deinem Alltag passt?",
  primaryCta: "Kostenloses Analysegespräch"
};

export const guaranteeData = {
  title: "Die \"Nur wenn's knallt\"-Garantie",
  subtitle: "Du sollst in den ersten Wochen direkt merken, dass sich schon etwas bewegt.",
  points: [
    "Wenn du nach 30 Tagen keine spürbare Veränderung hast, bauen wir dein System komplett neu auf. Das heißt: Wir schauen gemeinsam sehr konkret auf Training, Ernährung, Schlaf, Stress und Umsetzung und finden heraus, was bei dir gerade noch bremst. Danach bekommst du eine überarbeitete Version deines Systems, die besser zu deinem Alltag und deinem Körper passt – ohne Zusatzkosten.",
    "Was \"spürbare Veränderung\" bedeutet, ist bei jedem Mann etwas anderes – und genau so bewerten wir es auch. Es kann zum Beispiel sein, dass du morgens leichter rauskommst, tagsüber mehr Energie hast, der Brain Fog nachlässt, du im Training wieder Leistung aufbaust oder sich Körpergefühl und Umfang sichtbar verändern. Entscheidend ist nicht, dass du \"perfekt\" bist, sondern dass wir eine klare Bewegung in die richtige Richtung sehen.",
    "Und wenn es trotz Neuaufbau immer noch nicht passt, kannst du einfach kündigen. Ohne Kleingedrucktes, ohne Extra Kosten und ohne dass du dich rechtfertigen musst. Du sollst nur bleiben, wenn du wirklich merkst, dass es für dich funktioniert.",
    "Du zahlst hier nicht dafür, \"dabei zu sein\", sondern dafür, voranzukommen. Wenn du Fortschritt siehst, machen wir weiter. Wenn nicht, lösen wir es sauber – so einfach ist das."
  ]
};

export const stickyCtaData = {
  tagline: "Kostenlos & unverbindlich",
  title: "Analysegespräch",
  buttonText: "Termin buchen"
};

export const whatsAppSectionData = {
  headline: "Du bist unsicher, ob das Coaching passt?",
  subheadline: "Schreib mir deine Frage direkt auf WhatsApp.",
  buttonText: "Zu WhatsApp",
  bottomText: "Kein Chatbot. Du erreichst mich hier persönlich"
};

export const availableSpotsData = {
  current: 2,
  total: 10
};

export const dominoEffectData = {
  title: "Der Domino-Effekt",
  subtitle: "Warum die Basis alles entscheidet",
  basis: {
    title: "Die Basis",
    items: ["Schlaf", "Stress", "Ernährung"]
  },
  result: {
    title: "Das Resultat",
    items: ["Energie", "Leistung", "Körper"]
  },
  average: {
    label: "Durchschnittlicher Mann",
    effects: [
      { cause: "Schlechter Schlaf", result: "Heißhunger & Fressattacken" },
      { cause: "Chronischer Stress", result: "Trainingsplateau" },
      { cause: "Fehlende Struktur", result: "Unzuverlässige Umsetzung" }
    ],
    outcome: "Teufelskreis ohne Fortschritt"
  },
  primezeit: {
    label: "Primezeit Mann",
    effects: [
      { cause: "Erholsamerer Schlaf", result: "Stabilerer Appetit & Fokus" },
      { cause: "Kontrollierter Stress", result: "Konstante Fortschritte" },
      { cause: "Klare Routinen", result: "Planbarer Fortschritt" }
    ],
    outcome: "Aufwärtsspirale mit echten Ergebnissen"
  }
};

export const footerData = {
  links: [
    { label: "Home", url: "/" },
    { label: "Testimonials", url: "/#testimonials" },
    { label: "FAQ", url: "/#faq" },
    { label: "Kontakt", url: "/kontakt" }
  ],
  copyright: "© 2026 Primezeit System. Alle Rechte vorbehalten."
};

export const marqueeData = {
  row1: [
    "Nichts umgesetzt. Bis jetzt.",
    "Abnehmen ohne die nächste Crash-Diät.",
    "Endlich weiß ich, was ICH machen muss.",
    "30 Min Training reichen. Wer hätte das gedacht.",
    "Peptid-Hype verstanden. Entscheidungen werden klarer.",
  ],
  row2: [
    "Brain Fog weg. Ich funktioniere wieder.",
    "Schichtarbeit + Familie + Transformation = machbar.",
    "Kein Raten mehr. Endlich ein System.",
    "Ich war der Typ mit 1000 Tabs. Jetzt mache ich einfach.",
    "15 kg runter. Geht also doch.",
  ],
  row3: [
    "Grundlagen geordnet. Fortschritt wird messbar.",
    "Weniger raten. Mehr verstehen.",
    "Kopf ausschalten. System folgen. Funktioniert.",
    "Wöchentliche Kontrolle = ich kann nicht versagen.",
    "Jeder Influencer sagt was anderes. Arseni sagt, was ICH tun soll.",
    "Ich hatte 50 PDFs gespeichert. Jetzt habe ich ein System.",
  ]
};
